import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { MESSAGES_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiScalesToolRegistration } from '@Model';
import { type Column } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting, EnumUnit, getEnumUnitLabel } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ScalesRegistrationsRepository } from '@Repositories/Messages';

const columnNames: Column<ApiScalesToolRegistration>[] = [
    { name: 'label', label: 'Name' },
    { name: 'unit', label: 'Einheit', renderCell: ({ cellData }) => getEnumUnitLabel(cellData as EnumUnit) },
    { name: 'is_manual', label: 'Händische Waage' },
];

export function FrameListScaleToolRegistration() {
    const hasPermission = useHasPermission();

    const module = useListApi(ScalesRegistrationsRepository, MESSAGES_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.ScalesTableLayout}
            columns={columnNames}
            name={'WaageToolList'}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.MessagesScalesRegistrationCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
